const newModel = () => {
    return {
        truongMamnonId: null,
        tenTruong: null,
        truongId: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        tenMucTruongchuan: null,
        namCongNhan: null,
        quymoTruongchuanId: null,
        tenQuymoTruongchuan: null,
        namSatNhap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        gioiThieu: null,
        loaihinhTruongMamnonId: null,
        tenLoaihinhTruongMamnon: null,
        tenPhanloaiTruongMamnon: null,
        phanloaiTruongMamnonId: null,
        phuongXaId: null,
        tenPhuongXa: null,

        idKy: null,

        nhomTre: 0,
        lopMauGiao: 0,
        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,
        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,
        tongsoHocsinh: 0,
        tongsoHocsinhDadinhdanh: 0,
        hocsinhNu: 0,
        hocsinhDantocThieuso: 0,
        hocsinhKhuyettat: 0,
        hocsinhSuydinhduong: 0,
        hocsinh3den12M: 0,
        hocsinh13den24M: 0,
        hocsinh25den36M: 0,
        hocsinh3den4Y: 0,
        hocsinh4den5Y: 0,
        hocsinh5den6Y: 0,

        stt: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        xoaListHinhAnh: null, 
        xoaHinhAnh: null,

        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
truongMamnonId: null,
        tenTruong: null,
        truongId: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        tenMucTruongchuan: null,
        namCongNhan: null,
        quymoTruongchuanId: null,

        namSatNhap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        gioiThieu: null,
        loaihinhTruongMamnonId: null,
        phanloaiTruongMamnonId: null,
        phuongXaId: null,

        idKy: null,

        nhomTre: 0,
        lopMauGiao: 0,

        tongsoPhong: 0,
        phongKienco: 0,
        phongBankienco: 0,
        phongTam: 0,

        tongsoGiaovien: 0,
        giaovienNu: 0,
        giaovienDantocThieuso: 0,
        giaovienDatchuan: 0,
        
        tongsoHocsinh: 0,
        tongsoHocsinhDadinhdanh: 0,
        hocsinhNu: 0,
        hocsinhDantocThieuso: 0,
        hocsinhKhuyettat: 0,
        hocsinhSuydinhduong: 0,
        hocsinh3den12M: 0,
        hocsinh13den24M: 0,
        hocsinh25den36M: 0,
        hocsinh3den4Y: 0,
        hocsinh4den5Y: 0,
        hocsinh5den6Y: 0,

        stt: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        xoaListHinhAnh: null, 
        xoaHinhAnh: null,
    }
}

const fromJson = (item) => {
    return {
        truongMamnonId: item.truongMamnonId,
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        hieuTruong: item.hieuTruong,
        sdtHieuTruong: item.sdtHieuTruong,
        mucTruongchuanId: item.mucTruongchuanId,
        tenMucTruongchuan: item.tenMucTruongchuan,
        namCongNhan: item.namCongNhan,
        quymoTruongchuanId: item.quymoTruongchuanId,
        tenQuymoTruongchuan: item.tenQuymoTruongchuan,
        namSatNhap: item.namSatNhap,
        vemisId: item.vemisId,
        namThanhLap: item.namThanhLap,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        gioiThieu: item.gioiThieu,
        loaihinhTruongMamnonId: item.loaihinhTruongMamnonId,
        tenLoaihinhTruongMamnon: item.tenLoaihinhTruongMamnon,
        tenPhanloaiTruongMamnon: item.tenPhanloaiTruongMamnon,
        phanloaiTruongMamnonId: item.phanloaiTruongMamnonId,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        idKy: item.idKy,
        nhomTre: item.nhomTre,
        lopMauGiao: item.lopMauGiao,
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,
        tongsoHocsinh: item.tongsoHocsinh,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinhSuydinhduong: item.hocsinhSuydinhduong,
        hocsinh3den12M: item.hocsinh3den12M,
        hocsinh13den24M: item.hocsinh13den24M,
        hocsinh25den36M: item.hocsinh25den36M,
        hocsinh3den4Y: item.hocsinh3den4Y,
        hocsinh4den5Y: item.hocsinh4den5Y,
        hocsinh5den6Y: item.hocsinh5den6Y,
        stt: item.stt,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        xoaHinhAnh: item.xoaHinhAnh,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,

    }
}

const parseModeltoFEModel = (item) => {
    return {
        truongMamnonId: item.truongMamnonId,
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        hieuTruong: item.hieuTruong,
        sdtHieuTruong: item.sdtHieuTruong,
        mucTruongchuanId: item.mucTruongchuanId,
        tenMucTruongchuan: item.tenMucTruongchuan,
        namCongNhan: item.namCongNhan,
        quymoTruongchuanId: item.quymoTruongchuanId,
        namSatNhap: item.namSatNhap,
        vemisId: item.vemisId,
        namThanhLap: item.namThanhLap,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        ghiChu: item.ghiChu,
        gioiThieu: item.gioiThieu,
        loaihinhTruongMamnonId: item.loaihinhTruongMamnonId,
        phanloaiTruongMamnonId: item.phanloaiTruongMamnonId,
        phuongXaId: item.phuongXaId,
        idKy: item.idKy,
        nhomTre: item.nhomTre,
        lopMauGiao: item.lopMauGiao,
        tongsoPhong: item.tongsoPhong,
        phongKienco: item.phongKienco,
        phongBankienco: item.phongBankienco,
        phongTam: item.phongTam,
        tongsoGiaovien: item.tongsoGiaovien,
        giaovienNu: item.giaovienNu,
        giaovienDantocThieuso: item.giaovienDantocThieuso,
        giaovienDatchuan: item.giaovienDatchuan,
        tongsoHocsinh: item.tongsoHocsinh,
        tongsoHocsinhDadinhdanh: item.tongsoHocsinhDadinhdanh,
        hocsinhNu: item.hocsinhNu,
        hocsinhDantocThieuso: item.hocsinhDantocThieuso,
        hocsinhKhuyettat: item.hocsinhKhuyettat,
        hocsinhSuydinhduong: item.hocsinhSuydinhduong,
        hocsinh3den12M: item.hocsinh3den12M,
        hocsinh13den24M: item.hocsinh13den24M,
        hocsinh25den36M: item.hocsinh25den36M,
        hocsinh3den4Y: item.hocsinh3den4Y,
        hocsinh4den5Y: item.hocsinh4den5Y,
        hocsinh5den6Y: item.hocsinh5den6Y,
        stt: item.stt,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        xoaHinhAnh: item.xoaHinhAnh,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocEnabledDisplay: item.iocEnabled == 1 ? true : false,
        iocDateUpdated: item.iocDateUpdated,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        tenTruong: null,
        truongId: null,
        vemisId: null,
        mucTruongchuanId: null,
        quymoTruongchuanId: null,
        loaihinhTruongMamnonId: null,
        phanloaiTruongMamnonId: null,
        phuongXaId: null,
        enabled: null,
    }
}

const newSearchModel = (item) => {
    return {
        tenTruong: item.tenTruong,
        truongId: item.truongId,
        vemisId: item.vemisId,
        mucTruongchuanId: item.mucTruongchuanId,
        quymoTruongchuanId: item.quymoTruongchuanId,
        loaihinhTruongMamnonId: item.loaihinhTruongMamnonId,
        phanloaiTruongMamnonId: item.phanloaiTruongMamnonId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        truongMamnonId: null,
        tenTruong: null,
        truongId: null,
        hieuTruong: null,
        sdtHieuTruong: null,
        mucTruongchuanId: null,
        namCongNhan: null,
        quymoTruongchuanId: null,
        namSatNhap: null,
        vemisId: null,
        namThanhLap: null,
        gpsLong: null,
        gpsLat: null,
        ghiChu: null,
        gioiThieu: null,
        loaihinhTruongMamnonId: null,
        phanloaiTruongMamnonId: null,
        phuongXaId: null,
        tenPhuongXa: null,

        idKy: null,

        nhomTre: null,
        lopMauGiao: null,
        tongsoPhong: null,
        phongKienco: null,
        phongBankienco: null,
        phongTam: null,
        tongsoGiaovien: null,
        giaovienNu: null,
        giaovienDantocThieuso: null,
        giaovienDatchuan: null,
        tongsoHocsinh: null,
        tongsoHocsinhDadinhdanh: null,
        hocsinhNu: null,
        hocsinhDantocThieuso: null,
        hocsinhKhuyettat: null,
        hocsinhSuydinhduong: null,
        hocsinh3den12M: null,
        hocsinh13den24M: null,
        hocsinh25den36M: null,
        hocsinh3den4Y: null,
        hocsinh4den5Y: null,
        hocsinh5den6Y: null,

        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

//Customs
const reLoadDataFluctuations = (oldItem, dataFluctuations) => {
    let returnData = oldItem
    returnData.nhomTre = dataFluctuations.nhomTre
    returnData.lopMauGiao = dataFluctuations.lopMauGiao
    returnData.tongsoPhong = dataFluctuations.tongsoPhong
    returnData.phongKienco = dataFluctuations.phongKienco
    returnData.phongBankienco = dataFluctuations.phongBankienco
    returnData.phongTam = dataFluctuations.phongTam
    returnData.tongsoGiaovien = dataFluctuations.tongsoGiaovien
    returnData.giaovienNu = dataFluctuations.giaovienNu
    returnData.giaovienDantocThieuso = dataFluctuations.giaovienDantocThieuso
    returnData.giaovienDatchuan = dataFluctuations.giaovienDatchuan
    returnData.tongsoHocsinh = dataFluctuations.tongsoHocsinh
    returnData.tongsoHocsinhDadinhdanh = dataFluctuations.tongsoHocsinhDadinhdanh
    returnData.hocsinhNu = dataFluctuations.hocsinhNu
    returnData.hocsinhDantocThieuso = dataFluctuations.hocsinhDantocThieuso
    returnData.hocsinhKhuyettat = dataFluctuations.hocsinhKhuyettat
    returnData.hocsinhSuydinhduong = dataFluctuations.hocsinhSuydinhduong
    returnData.hocsinh3den12M = dataFluctuations.hocsinh3den12M
    returnData.hocsinh13den24M = dataFluctuations.hocsinh13den24M
    returnData.hocsinh25den36M = dataFluctuations.hocsinh25den36M
    returnData.hocsinh3den4Y = dataFluctuations.hocsinh3den4Y
    returnData.hocsinh4den5Y = dataFluctuations.hocsinh4den5Y
    returnData.hocsinh5den6Y = dataFluctuations.hocsinh5den6Y
    return returnData
}



export const truongMamNonGD_v2Model = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
    reLoadDataFluctuations,
}


